<script>
// @ts-check

import { mapGetters } from 'vuex'

export default {
  name: 'NavigationLink',
  props: {
    route: {
      /** @type {import('vue').PropType<import('vue-router').Route>} */
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ['click'],
  computed: {
    ...mapGetters('app', ['isTlpService', 'isOyService']),
    serviceClass() {
      return this.isTlpService
        ? 'text-white hover:bg-curtain-white focus:bg-curtain-white'
        : 'text-secondary-300 hover:bg-secondary-600 focus:bg-secondary-600'
    },
    linkActiveClass() {
      if (this.isTlpService) {
        return 'border-white bg-curtain-white'
      }

      return 'active-navigation-link'
    }
  },
  methods: {
    /**
     *
     * @param {import('vue-router').Route} route
     */
    getRouteName(route) {
      let { name } = route

      if (this.isTlpService && name === 'incomes') {
        name = 'invoices'
      }

      if (this.isOyService && name === 'reports') {
        name = 'reports_and_documents'
      }

      return this.$t(`routes.${name}`)
    }
  }
}
</script>

<template>
  <RouterLink
    class="navigation-link"
    :class="[
      serviceClass,
      {
        'mb-8!':
          (route.name === 'analytics' && !isOyService) ||
          (route.name === 'driving_logs' && !isOyService) ||
          route.name === 'courier' ||
          route.name === 'setup',
        'mt-8!':
          (route.name === 'customers' && isOyService) ||
          (route.name === 'settings' && isOyService)
      }
    ]"
    :active-class="linkActiveClass"
    :to="{ name: route.name }"
    @click="disabled ? null : $emit('click')"
  >
    <VIcon
      :icon="route.meta?.icon"
      size="1.5rem"
      class="mr-6 text-secondary-300 transition duration-150 ease-in-out group-hover:text-secondary-300 group-focus:text-secondary-300"
    />

    <VBadge v-if="route.meta.new" class="absolute top-3" color="primary" dot />

    {{ getRouteName(route) }}

    <span class="error-message">
      {{ route.name === 'setup' ? '!' : '' }}
    </span>
  </RouterLink>
</template>
